import { useEffect } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";

const SessionPreview = ({
  auditorOption,
  assignedAuditors,
  dummyDepartments,
  onEdit,
  onDelete,
  dummyAreas = [],
}) => {

  return (
    <div className="card">
      <div className="p-2 border-bottom">
        <h5 className="m-0">Session Preview</h5>
      </div>
      <div className="card-body">
        <div
          className="overflow-auto scroll-container mb-4"
          style={{ maxHeight: "400px" }}
        >
          {assignedAuditors.length === 0 ? (
            <div className="bg-light text-dark py-3 text-center">
              No Auditor Found
            </div>
          ) : (
            assignedAuditors.map((auditor) => (
              <div key={auditor.id} className="mb-2 card rounded-3 p-2">
                {/* Header with Edit/Delete */}
                <div className="d-flex justify-content-between gap-2">
                  <strong>
                    {auditorOption.find((item) => item.value == auditor.id)
                      ?.label || "-"}
                  </strong>
                  <div className="align-self-start">
                    {/* Edit Button */}
                    <span
                      className="p-1 btn btn-outline-light ms-1"
                      onClick={() => onEdit(auditor)}
                    >
                      <FiEdit2 className="text-dark" />
                    </span>
                    {/* Delete Button */}
                    <span
                      className="p-1 btn btn-outline-light ms-1"
                      onClick={() => onDelete(auditor.id)}
                    >
                      <FiTrash2 className="text-dark" />
                    </span>
                  </div>
                </div>

                {/* Department Names */}
                <span
                  className="fw-medium text-dark"
                  style={{ fontSize: "0.8rem" }}
                >
                  Departments:
                </span>
                <small className="text-darker">
                  {auditor.departments
                    .map(
                      (deptId) =>
                        dummyDepartments.find((d) => d.value === deptId)
                          ?.label || deptId
                    )
                    .join(", ")}
                </small>
                <span
                  className="fw-medium text-dark"
                  style={{ fontSize: "0.8rem" }}
                >
                  {auditor.areas.length} Areas assigned
                </span>
                <small className="text-darker">
                  {auditor.areas.length > 0
                    ? (() => {
                        const areaNames = auditor.areas.map(
                          (area) =>
                            dummyAreas.find((a) => a.value ==area?.area_id)?.label
                        );

                        const displayed = areaNames.slice(0, 3).join(", ");

                        return areaNames.length > 3
                          ? `Areas: ${displayed}...`
                          : `Areas: ${displayed}`;
                      })()
                    : "No areas selected"}
                </small>
              </div>
            ))
          )}
        </div>

        {/* ✅ SESSION SUMMARY */}
        <hr className="my-3" />
        <h5>Session Summary</h5>
        <div className="mt-2">
          {/* Total Auditors */}
          <p
            className="d-flex border-bottom justify-content-between flex-wrap m-0"
            style={{ padding: "0.35rem 0" }}
          >
            <span className="text-dark fw-medium fs-6">Total Auditors:</span>
            <span className="text-darker fw-medium">
              {assignedAuditors.length}
            </span>
          </p>

          {/* Total Areas */}
          <p
            className="d-flex border-bottom justify-content-between flex-wrap m-0 fs-6"
            style={{ padding: "0.4rem 0" }}
          >
            <span className="text-dark fw-medium">Total Areas:</span>
            <span className="text-darker fw-medium">
              {assignedAuditors.reduce((acc, cur) => acc + cur.areas.length, 0)}
            </span>
          </p>

          {/* Total Departments */}
          <p
            className="d-flex justify-content-between flex-wrap fs-6"
            style={{ padding: "0.35rem 0" }}
          >
            <span className="text-dark fw-medium">Departments:</span>{" "}
            <span className="text-darker fw-medium">
              {new Set(assignedAuditors.flatMap((a) => a.departments)).size}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SessionPreview;
